<template>
  <div class="event-stats md-layout">
    <div class="md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-20 md-small-size-10 md-xsmall-size-100" />
    <div
      class="md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-30 md-xsmall-size-100"
    >
      <div class="md-layout title">
        <img
          alt="kab logo"
          :src="require(`@/assets/people.svg`)"
        >
        {{ stats.all }}
      </div>
      <div class="paragraph">
        Attendees 
      </div>
    </div> 
    <div
      class="md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-30 md-xsmall-size-100"
    >
      <div class="md-layout title">
        <img
          alt="kab logo"
          :src="require(`@/assets/exhibit.svg`)"
        >
        {{ stats.exhibitors }}
      </div>
      <div class="paragraph">
        Masters/Studios 
      </div>
    </div> 
    <div
      class="md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-30 md-xsmall-size-100"
    >
      <div class="md-layout title">
        <img
          alt="kab logo"
          :src="require(`@/assets/country.svg`)"
        >
        {{ stats.apprentices }}
      </div>
      <div class="paragraph">
        Apprentices 
      </div>
    </div> 
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: "EventStats",
  computed: {
    ...mapState(['stats'])
  },
  async created () {
    await this.$nextTick()
    this.getStats()
  },
  methods: {
    async getStats() {
      try {
        await this.$store.dispatch('getStats')
      } catch (error) {
        throw Error(error)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.title {
  height: 31px;
  font-size: 24px;
  font-weight: bold;
  line-height: 1.29;
  color: $color-primary;
  img {
    margin-right: 5px;
    margin-left: 13px;
  }
}

.paragraph {
  width: 67px;
  height: 21px;
  font-size: 14px;
  line-height: 1.5;
  color: $color-white;
  text-indent: 43px;
}
.event-stats {
  position: relative;
  margin-top: 20px;
}

@media only screen and (max-width: 600px) {
  .event-stats {
    position: relative;
    margin-top: 60px;
  }
}

@media only screen and (max-width: 400px) {
  .event-stats {
    margin-top: 60px;
    margin-left: 30px;
  }
}

@media only screen and (max-width: 375px) {
  .event-stats {
    margin-top: -100px;
    margin-left: 25px;
  }
}

@media only screen and (max-width: 360px) {
  .event-stats {
    margin-top: 60px;
  }
}

@media only screen and (max-width: 320px) {
  .event-stats {
    display: none;
  }
}

@media only screen and (max-width: 832px) and (orientation: landscape) {
  .event-stats {
    display: none;
  }
}

@media only screen and (max-width: 1024px) and (orientation: landscape) {
  .event-stats {
    margin-top: -70px;
  }
}

@media only screen and (min-width: 1366px) and (max-width: 1366px) {
  .event-stats {
    position: relative;
    margin-top: 30px;
  }
}

</style>
